function getIdentityIdByIndex(identityIndex) {
  return this.state.identities.get(identityIndex);
}
module.exports = getIdentityIdByIndex;
